import { useCallback, useEffect, useState } from "react";
import { useAuth } from "react-oidc-context";
import { useNitroStore } from "../../store/Store";
import "./index.css";
import { useIsMobile } from "../../hooks/useIsMobile";
import { useNitroCAStore } from "../../store/CompetitiveAnalysisStore";
import CompetitiveAnalysisPanel from "./panel";
import NitroModal from "../../components/Modal";

const CompetitiveAnalysisModal = () => {
  const isMobile = useIsMobile(1334);

  const [
    currentFilters,
    product,
    mode,
    showCompetitiveAnalysisModal,
    selectedLocation,
    uom,
    currency,
    showAddFOBIndicationPanel,
  ] = useNitroStore((state) => [
    state.currentFilters,
    state.product,
    state.mode,
    state.showCompetitiveAnalysisModal,
    state.selectedLocation,
    state.uom,
    state.currency,
    state.showAddFOBIndicationPanel,
  ]);

  const [load, reloadAfterTroubleshoot] = useNitroCAStore((state) => [
    state.load,
    state.reloadAfterTroubleshoot,
  ]);

  const auth = useAuth();
  const user = `${auth.user?.profile.given_name} ${auth.user?.profile.family_name}`;

  const [railType, setRailType] = useState<
    "single" | "85+" | "100+" | undefined
  >("single");

  const loadRecords = useCallback(() => {
    if (!selectedLocation) return;
    load({
      marketer: user,
      destination: selectedLocation.name,
      shipDate: currentFilters.month || "",
      product,
      currency: currency || "USD",
      uom: uom || "ST",
      mode,
      railType,
    });
  }, [
    selectedLocation,
    load,
    user,
    currentFilters.month,
    product,
    currency,
    uom,
    mode,
    railType,
  ]);

  useEffect(() => {
    if (reloadAfterTroubleshoot > 0) {
      loadRecords();
    }
  }, [reloadAfterTroubleshoot, loadRecords]);

  return (
    <NitroModal
      id="competitive-analysis-modal"
      className={`${
        showAddFOBIndicationPanel
          ? "competitiveAnalysisHide"
          : "competitiveAnalysisModal"
      }`}
      open={showCompetitiveAnalysisModal}
      style={{
        zIndex: 21,
        ...(isMobile && {
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          margin: 0,
          maxWidth: "none",
          maxHeight: "none",
        }),
      }}
    >
      <div
        style={{
          position: "relative",
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          width: "100%",
        }}
      >
        {selectedLocation && (
          <CompetitiveAnalysisPanel
            reload={() => loadRecords()}
            selectedLocation={selectedLocation}
            railType={railType}
            setRailType={setRailType}
          />
        )}
      </div>
    </NitroModal>
  );
};

export default CompetitiveAnalysisModal;
